/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useShowError } from "~/components/Error/useShowError";
import { ProductIdRouteParams } from "~/models/product";
import { Sla } from "~/models/sla";
import { useAxios } from "~/tools";

const useSla = () => {
  const state = useParams<ProductIdRouteParams>();
  const { productId } = state;
  const [sla, setSla] = useState<Sla[]>([]);

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchSLA = useCallback(async () => {
    try {
      const { data } = await Axios().get(`/catalog/products/${productId}/slas`);
      setSla(data.slas);
    } catch (e) {
      showError(e.response);
    }
  }, [Axios, productId, showError]);

  useEffect(() => {
    fetchSLA();
  }, [fetchSLA]);

  return {
    sla,
    fetchSLA,
  };
};

export { useSla };
